export default __webpack_public_path__ + "static/media/std-dev-icon.94ed180e.svg";